var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseAnimation",
    {
      attrs: {
        attr: {
          opacity: 1,
          y: 0,
          delay: 0.25 * _vm.index
        }
      }
    },
    [
      _c(
        "li",
        { staticClass: "animation-shape" },
        [
          _c(
            "div",
            { staticClass: "participation__item-inner" },
            [
              _c("ShapeNumberItem", {
                attrs: { index: _vm.index, src: "shape-number" }
              })
            ],
            1
          ),
          _vm.item.caption
            ? _c("BaseCaption", { attrs: { text: _vm.item.caption } })
            : _vm._e(),
          _vm.item.descr
            ? _c("BaseText", { attrs: { text: _vm.item.descr } })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f9c947", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f9c947","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ShapeListItem.vue
// module id = IXZG
// module chunks = 0